import React from 'react';
import PropTypes from 'prop-types';

const StatusIndicator = ({
	state,
}) => {
	const getlabelClass = () => {
		if (state?.color) {
			return state?.color;
		}

		return 'info';
	};

	return (
		<>
			{state?.name && (
				<div
					className={`status-indicator color-${getlabelClass()}`}
				>
					{state?.name}
				</div>
			)}
		</>
	);
};

export default StatusIndicator;

StatusIndicator.propTypes = {
	state: PropTypes.objectOf.isRequired,
};
